
import { apis } from "apis";
import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";

/**
 * 店铺推广弹窗服务
 * @class
 * @version 1.0.0
 */
export default class EmployerStorePopupService extends ServiceBase
{

    /*
     * 店铺推广弹窗服务
     * @private
     * @return EmployerActivityService
     */
    private static _instance: EmployerStorePopupService;

    /**
     * 店铺推广弹窗服务
     * @static
     * @property
     * @returns EmployerActivityService
     */
    public static get instance(): EmployerStorePopupService
    {
        if(!this._instance)
        {
            this._instance = new EmployerStorePopupService();
        }
        
        return this._instance;
    }
    
    /**
     * 获取推广弹窗广告
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getStorePopup(popupPosition: any): Promise<IHttpResponse>
    {

        let response = await this.apis.getStorePopup({params: {popupPosition}});
        return response;
    }

    
}
